import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import { DialogTitleWithClose } from '../../common';

/**
 * PromoteVersionDialog Component
 * Dialog for promoting a version to active status
 */
const PromoteVersionDialog = ({
  open,
  onClose,
  onConfirm,
  version,
  loading,
}) => {
  const handleConfirm = async () => {
    // Pass the full version object to allow promoteVersion to extract version number properly
    const success = await onConfirm(version);
    if (success) {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitleWithClose
        title="Promote Version"
        onClose={onClose}
        disableClose={loading}
      />
      <DialogContent>
        <Typography>
          Are you sure you want to promote this version to active status? This
          will make it the current version of the template.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="success"
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : 'Promote'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PromoteVersionDialog;
